/*
  Conso — Área de membros: compre e ganhe (sections/conso-area-brinde.liquid)

  Dois cards: (1) a peça comprada — modelo, cor, tamanho; (2) a camiseta de
  brinde — lista os modelos e, escolhido um, cor e tamanho. "Adicionar" manda as duas linhas num /cart/add.js, a
  camiseta com o marcador (propBrinde) que a function compre-ganhe exige.

  Variante no JSON: [id, cor, tamanho, disponível, preço, compare_at] (centavos).
  Evento (dataLayer): conso_area_brinde_add.
*/
(function () {
  'use strict';

  var SEL_ROOT = '[data-conso-area-brinde]';

  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function rotas() {
    return (window.Theme && window.Theme.routes) || window.routes || {};
  }

  function dinheiro(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  var SVG_CASHBACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M14.5 9.2c-.4-.8-1.3-1.3-2.5-1.3-1.4 0-2.4.7-2.4 1.8 0 2.5 4.8 1.2 4.8 3.7 0 1.1-1 1.9-2.4 1.9-1.2 0-2.2-.6-2.5-1.5"/><path d="M12 6.8v1.1M12 15.8v1.2"/></svg>';

  /* Conteúdo da linha de cashback (mesmo texto do snippet conso-cashback-linha). */
  function preencherCashback(alvo, valorCents, dados) {
    var pct = dados.cashbackPct * (dados.cashbackDobro ? 2 : 1);
    alvo.innerHTML = SVG_CASHBACK;
    var t = document.createElement('span');
    t.appendChild(document.createTextNode('Compre e receba de volta '));
    var b = document.createElement('b');
    b.textContent = dinheiro(Math.floor(valorCents * pct / 100));
    t.appendChild(b);
    t.appendChild(document.createTextNode(' em Cashback'));
    if (dados.cashbackDobro) {
      t.appendChild(document.createTextNode(' '));
      var d = document.createElement('b');
      d.textContent = 'em dobro';
      t.appendChild(d);
    }
    alvo.appendChild(t);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ------------------------------------------------------------ carrinho */

  function idsDeSecaoDoCarrinho() {
    return Array.prototype.slice
      .call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (n) { return n.dataset.sectionId; })
      .filter(Boolean);
  }

  function mensagemDeErro(dados) {
    var errors = dados && dados.errors;
    if (typeof errors === 'string' && errors.trim()) return errors;
    if (errors && typeof errors === 'object') {
      var lista = [].concat.apply([], Object.keys(errors).map(function (k) { return [].concat(errors[k]); }));
      var primeira = lista.find(function (m) { return typeof m === 'string' && m.trim(); });
      if (primeira) return primeira;
    }
    return (dados && (dados.description || dados.message)) || 'Não foi possível adicionar ao carrinho.';
  }

  function postCarrinho(itens) {
    var corpo = { items: itens };
    var secoes = idsDeSecaoDoCarrinho();
    if (secoes.length) {
      corpo.sections = secoes.join(',');
      corpo.sections_url = window.location.pathname;
    }
    return fetch(rotas().cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().then(function (dados) {
        if (!r.ok || dados.status) throw new Error(mensagemDeErro(dados));
        return dados;
      });
    });
  }

  function carrinhoAtual() {
    return fetch((rotas().cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Evento legado de propósito (mesmo do conso-kit-brinde): a ponte
     conso-cart-event-bridge.js converte pro formato da 4.x e atualiza a
     sacola sem abrir; quem abre é abrirSacola. */
  function avisarTema(carrinho, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: carrinho,
        sourceId: 'conso-area-brinde',
        data: { itemCount: Number((carrinho && carrinho.item_count) || 0), source: 'conso-area-brinde', sections: sections }
      }
    }));
  }

  function abrirSacola() {
    var drawer = document.querySelector('cart-drawer-component');
    var theme = drawer && drawer.closest('theme-drawer');
    if (theme && typeof theme.open === 'function') return theme.open();
    if (drawer && typeof drawer.open === 'function') return drawer.open();
    var gatilho = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (gatilho) gatilho.click();
  }

  /* --------------------------------------------------------------- dados */

  function coresComEstoque(p) {
    var ok = {};
    p.variantes.forEach(function (v) { if (v[3]) ok[v[1]] = true; });
    return p.cores.filter(function (c) { return ok[c.nome]; });
  }
  function tamanhosDa(p, cor) {
    return p.variantes.filter(function (v) { return v[1] === cor; });
  }
  function varianteDe(p, cor, tam) {
    return p.variantes.find(function (v) { return v[1] === cor && v[2] === tam && v[3]; }) || null;
  }
  function temEstoque(p) {
    return p.variantes.some(function (v) { return v[3]; });
  }
  function fotoDe(p, cor) {
    var c = p.cores.find(function (x) { return x.nome === cor; });
    return (c && c.img) || p.imagem;
  }
  function precoRef(p, cor) {
    var vs = p.variantes.filter(function (v) { return v[3] && (!cor || v[1] === cor); });
    if (!vs.length) vs = p.variantes;
    var v = vs.reduce(function (a, b) { return b[4] < a[4] ? b : a; });
    return { preco: v[4], compare: v[5] };
  }
  /* Kit: preço por unidade pela escada custom.desconto_progressivo — a mesma conta
     da function desconto-progressivo e do conso-kit-opcoes (percentual trunca o
     desconto no centavo; fixo subtrai reais). Degrau = maior quantidade <= n. */
  function precoKit(p, precoUnit, n) {
    var cfg = p.escada;
    var tiers = (cfg && cfg.tiers) || [];
    var melhor = null;
    tiers.forEach(function (t) {
      var q = Number(t.quantidade);
      if (q <= n && Number(t.valor) > 0 && (!melhor || q > Number(melhor.quantidade))) melhor = t;
    });
    var desc = 0;
    if (melhor) {
      desc = cfg.tipo === 'fixo'
        ? Math.round(Number(melhor.valor) * 100)
        : Math.floor(precoUnit * Number(melhor.valor) / 100);
    }
    var unit = Math.max(0, precoUnit - desc);
    return { unit: unit, total: unit * n, cheio: precoUnit * n, pct: melhor && cfg.tipo !== 'fixo' ? Number(melhor.valor) : 0 };
  }

  function img(src, alt, cls) {
    var i = el('img', cls);
    if (src) i.src = src;
    i.alt = alt || '';
    i.loading = 'lazy';
    i.width = 600;
    i.height = 750;
    return i;
  }

  /* --------------------------------------------------------------- init */

  function init(root) {
    if (root.__consoBrinde) return;
    root.__consoBrinde = true;

    var script = root.querySelector('[data-conso-area-brinde-dados]');
    if (!script) return;
    var dados;
    try { dados = JSON.parse(script.textContent); } catch (e) { return; }

    var principais = dados.principais.filter(temEstoque);
    var brindes = (dados.brindes || []).filter(temEstoque);
    /* semBrinde: só o kit (sem passo 2). Usado nos kits da Área de membros, onde o
       desconto é a escada pública e não há brinde. */
    var semBrinde = !!dados.semBrinde;
    if (!principais.length || (!semBrinde && !brindes.length)) return;

    var ui = {
      principal: root.querySelector('[data-card="principal"]'),
      brinde: root.querySelector('[data-card="brinde"]'),
      total: root.querySelector('[data-total]'),
      dica: root.querySelector('[data-dica]'),
      cashback: root.querySelector('[data-cashback]'),
      cta: root.querySelector('[data-cta]'),
      erro: root.querySelector('[data-erro]')
    };
    var oferta = root.dataset.oferta || '';
    var rotuloCta = ui.cta.textContent;

    /* Nome no botão de modelo sem o prefixo comum ("Camisa Social Anti-Amassado
       Flex Office" → "Flex Office"): cortado em 3 linhas, os modelos ficavam iguais. */
    var prefixos = (dados.prefixosNome || []).map(function (x) { return String(x).trim(); }).filter(Boolean);
    function nomeCurto(titulo) {
      for (var i = 0; i < prefixos.length; i++) {
        if (titulo.toLowerCase().indexOf(prefixos[i].toLowerCase()) === 0) {
          var resto = titulo.slice(prefixos[i].length).trim();
          if (resto) return resto;
        }
      }
      return titulo;
    }

    /* Preço exibido (setting preco_modo). Só vitrine: quem cobra é a function.
       percentual: X% na unidade, truncado no centavo (conta do conso-price);
       pague: leve N, pague M — total = preço × M (conta da tres-por-dois). */
    var precoModo = dados.precoModo || 'escada';
    var descontoPct = Number(dados.descontoPct) || 0;
    /* Desconto do SALE do produto (function desconto-produto), a mesma conta que ela
       cobra: fixo em reais por unidade; percentual truncado no centavo. */
    function descontoSale(preco, p) {
      var sale = p && p.sale;
      if (!sale || !(sale.valor > 0)) return 0;
      if (sale.tipo === 'fixo') return Math.min(preco, Math.round(sale.valor * 100));
      if (sale.tipo === 'percentual' && sale.valor <= 100) return Math.floor(preco * sale.valor / 100);
      return 0;
    }

    /* Preço da unidade.
       - sale: o desconto é o do site (SALE do produto), sem promo própria da área.
       - percentual: o % da oferta (promo-membros-camisetas). O SALE também incide nas
         linhas daqui e não combina com ele: a Shopify cobra o MAIOR dos dois.
       Sem o produto (p), o SALE não entra. */
    function precoUnidade(preco, p) {
      if (precoModo === 'sale') return Math.max(0, preco - descontoSale(preco, p));
      if (precoModo !== 'percentual' || !descontoPct) return preco;
      var desc = Math.floor(preco * descontoPct / 100);
      var ds = descontoSale(preco, p);
      if (ds > desc) desc = ds;
      return Math.max(0, preco - desc);
    }
    var propsExtra = null;
    try { propsExtra = dados.propsExtra ? JSON.parse(dados.propsExtra) : null; } catch (e) { propsExtra = null; }

    function selecaoInicial(p) {
      var cores = coresComEstoque(p);
      return { p: p, cor: cores.length ? cores[0].nome : '', tam: '' };
    }

    /* Kit (unidades > 1): o cliente escolhe o modelo e cada unidade ganha um select
       próprio de variante (cor / tamanho). */
    var unidades = Math.max(1, Number(dados.unidades) || 1);
    var ehKit = unidades > 1;

    /* Brinde: "escolha" = 1 camiseta entre as da lista; "todos" = uma de CADA, todas
       obrigatórias. `brindesPorProduto` restringe a lista pelo produto comprado
       (ex: a polo ganha só 2 modelos). */
    var brindeTodos = dados.brindeModo === 'todos';
    function brindesDe(p) {
      var mapa = dados.brindesPorProduto || {};
      var lista = mapa[p.handle];
      if (!lista || !lista.length) return brindes;
      var r = brindes.filter(function (b) { return lista.indexOf(b.handle) !== -1; });
      return r.length ? r : brindes;
    }
    function montarBrindesTodos(anterior) {
      return brindesDe(sel.principal.p).map(function (b) {
        var velho = (anterior || []).find(function (s) { return s.p === b; });
        return velho || selecaoInicial(b);
      });
    }
    function montarSlots() {
      var r = [];
      for (var i = 0; i < unidades; i++) r.push({ p: sel.principal.p, cor: '', tam: '' });
      return r;
    }

    var sel = {
      principal: selecaoInicial(principais[0]),
      slots: [],
      slotAtivo: 0,
      /* passo 2 nasce com a primeira camiseta escolhida, igual ao passo 1 */
      brinde: semBrinde ? null : selecaoInicial(brindes[0])
    };
    sel.slots = montarSlots();
    sel.brindesTodos = brindeTodos ? montarBrindesTodos() : [];
    var enviando = false;

    /* ---- peças do card ---- */

    /* opcoes.carrossel: fileira com scroll-snap em vez de grade.
       opcoes.selo: texto no canto inferior da foto (sem uso desde que o "3x"
       saiu dos kits, 16/10/2026). */
    function modelos(lista, atual, onPick, gratis, opcoes) {
      opcoes = opcoes || {};
      var wrap = el('div', 'conso-area-brinde__modelos' +
        (gratis ? ' conso-area-brinde__modelos--grade' : '') +
        (opcoes.carrossel ? ' conso-area-brinde__modelos--carrossel' : ''));
      wrap.setAttribute('role', 'radiogroup');
      lista.forEach(function (p) {
        var b = el('button', 'conso-area-brinde__modelo');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', atual === p ? 'true' : 'false');
        var thumb = el('span', 'conso-area-brinde__modelo-thumb');
        thumb.appendChild(img(p.imagem, '', 'conso-area-brinde__modelo-img'));
        if (opcoes.selo) thumb.appendChild(el('span', 'conso-area-brinde__modelo-selo', opcoes.selo));
        b.appendChild(thumb);
        var info = el('span', 'conso-area-brinde__modelo-info');
        info.appendChild(el('span', 'conso-area-brinde__modelo-nome', nomeCurto(p.titulo)));
        if (gratis) {
          var pr = el('span', 'conso-area-brinde__modelo-preco');
          pr.appendChild(el('s', '', dinheiro(precoRef(p).preco)));
          pr.appendChild(el('strong', '', ' ' + dados.rotuloGratis));
          info.appendChild(pr);
        }
        b.appendChild(info);
        b.addEventListener('click', function () { onPick(p); });
        wrap.appendChild(b);
      });
      return wrap;
    }

    function escolhas(s, onChange) {
      var p = s.p;
      var frag = document.createDocumentFragment();

      var gCor = el('div', 'conso-area-brinde__grupo');
      var lCor = el('p', 'conso-area-brinde__grupo-rotulo');
      lCor.appendChild(document.createTextNode(p.rotuloCor + ': '));
      lCor.appendChild(el('strong', '', s.cor || '—'));
      gCor.appendChild(lCor);
      var cores = el('div', 'conso-area-brinde__cores');
      coresComEstoque(p).forEach(function (c) {
        var b = el('button', 'conso-area-brinde__cor');
        b.type = 'button';
        b.title = c.nome;
        b.setAttribute('aria-label', c.nome);
        b.setAttribute('aria-pressed', s.cor === c.nome ? 'true' : 'false');
        var bolinha = el('span', 'conso-area-brinde__cor-swatch');
        if (c.swatch) bolinha.style.background = c.swatch;
        else bolinha.textContent = c.nome.slice(0, 2);
        b.appendChild(bolinha);
        b.addEventListener('click', function () {
          s.cor = c.nome;
          if (s.tam && !varianteDe(p, s.cor, s.tam)) s.tam = '';
          onChange();
        });
        cores.appendChild(b);
      });
      gCor.appendChild(cores);
      frag.appendChild(gCor);

      var gTam = el('div', 'conso-area-brinde__grupo');
      var lTam = el('p', 'conso-area-brinde__grupo-rotulo');
      lTam.appendChild(document.createTextNode(p.rotuloTamanho + ': '));
      lTam.appendChild(el('strong', '', s.tam || 'escolha'));
      gTam.appendChild(lTam);
      var tams = el('div', 'conso-area-brinde__tamanhos');
      tamanhosDa(p, s.cor).forEach(function (v) {
        var b = el('button', 'conso-area-brinde__tamanho', v[2]);
        b.type = 'button';
        b.disabled = !v[3];
        if (!v[3]) b.title = dados.rotuloEsgotado;
        b.setAttribute('aria-pressed', s.tam === v[2] ? 'true' : 'false');
        b.addEventListener('click', function () { s.tam = v[2]; onChange(); });
        tams.appendChild(b);
      });
      gTam.appendChild(tams);
      frag.appendChild(gTam);
      return frag;
    }

    function produtoCard(s, gratis, onChange, onTrocar) {
      var p = s.p;
      var v = varianteDe(p, s.cor, s.tam);
      var ref = v ? { preco: v[4], compare: v[5] } : precoRef(p, s.cor);

      var box = el('div', 'conso-area-brinde__produto');
      box.appendChild(mediaDe(p, s.cor || (coresComEstoque(p)[0] || {}).nome, fotoDe(p, s.cor)));

      var info = el('div', 'conso-area-brinde__info');
      info.appendChild(el('p', 'conso-area-brinde__nome', p.titulo));
      if (gratis) {
        var preco = el('p', 'conso-area-brinde__preco');
        preco.appendChild(el('s', '', dinheiro(ref.preco)));
        preco.appendChild(el('strong', 'conso-area-brinde__gratis', dados.rotuloGratis));
        info.appendChild(preco);
      } else {
        var final = precoUnidade(ref.preco, p);
        info.appendChild(precoBaixou(final, final < ref.preco ? ref.preco : ref.compare));
      }
      /* desktop: cashback abaixo do preço (no mobile ele fica no rodapé) */
      if (!gratis && dados.cashbackPct > 0) {
        var cbCard = el('div', 'conso-cashback-linha conso-area-brinde__cashback-card');
        preencherCashback(cbCard, precoUnidade(ref.preco, p), dados);
        info.appendChild(cbCard);
      }
      if (!gratis) info.appendChild(chipsCupom(precoUnidade(ref.preco, p)));
      if (p.sizing) {
        /* Aberto pelo conso-kit-medidas.js (delegação no document), que acha a
           gaveta subindo até o [data-kmm-escopo] desta section. */
        var med = el('button', 'conso-area-brinde__medidas');
        med.type = 'button';
        med.setAttribute('data-km-medidas', p.sizing);
        med.setAttribute('data-km-medidas-titulo', p.titulo);
        if (p.provador) med.setAttribute('data-km-medidas-provador', '');
        med.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>';
        med.appendChild(document.createTextNode(dados.rotuloMedidas));
        info.appendChild(med);
      }
      info.appendChild(escolhas(s, onChange));
      if (onTrocar) {
        var t = el('button', 'conso-area-brinde__trocar', dados.rotuloTrocar);
        t.type = 'button';
        t.addEventListener('click', onTrocar);
        info.appendChild(t);
      }
      box.appendChild(info);
      return box;
    }

    /* Chips do cupom (snippet conso-cupom-checkbox, renderizados escondidos pela
       section, um por perfil): uma cópia vai no card, acima de "Medidas e provador",
       com o preço com cupom sobre o que o cliente paga (desconto truncado no
       centavo, como no checkout). O checkbox sincroniza pelo conso-aplicar-cupom.js. */
    var chipsModelo = Array.prototype.slice.call(root.querySelectorAll('[data-cupom-chips] .conso-pb__cupom'));
    function chipsCupom(valorCents) {
      var frag = document.createDocumentFragment();
      chipsModelo.forEach(function (modelo) {
        var chip = modelo.cloneNode(true);
        var pct = Number(chip.getAttribute('data-cupom-pct')) || 0;
        var alvo = chip.querySelector('[data-cupom-valor]');
        if (alvo) alvo.textContent = dinheiro(valorCents - Math.floor(valorCents * pct / 100));
        chip.classList.add('conso-area-brinde__cupom');
        frag.appendChild(chip);
      });
      return frag;
    }

    /* Preço no desenho da PDP "preço baixou" (snippet conso-preco-baixou, CSS
       conso-preco-baixou.css): tag "PREÇO BAIXOU" + "Antes era R$ X" quando há preço
       anterior, e o preço embaixo. Sem preço anterior, só o preço. */
    var SVG_SETA = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 2v11M3.5 8.5 8 13l4.5-4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function precoBaixou(final, antes) {
      var box = el('div', 'conso-pb conso-area-brinde__pb');
      if (antes && antes > final) {
        var topo = el('div', 'conso-pb__topo');
        var tag = el('span', 'conso-pb__tag');
        tag.innerHTML = SVG_SETA;
        tag.appendChild(document.createTextNode('PREÇO BAIXOU'));
        topo.appendChild(tag);
        topo.appendChild(el('span', 'conso-pb__antes', 'Antes era ' + dinheiro(antes)));
        box.appendChild(topo);
      }
      box.appendChild(el('div', 'conso-pb__preco', dinheiro(final)));
      return box;
    }

    /* ---- render ---- */

    function botaoMedidas(p) {
      var med = el('button', 'conso-area-brinde__medidas');
      med.type = 'button';
      med.setAttribute('data-km-medidas', p.sizing);
      med.setAttribute('data-km-medidas-titulo', p.titulo);
      if (p.provador) med.setAttribute('data-km-medidas-provador', '');
      med.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>';
      med.appendChild(document.createTextNode(dados.rotuloMedidas));
      return med;
    }

    /* "Detalhes da peça": abre a popup do conso-area-detalhes.js (delegação no
       document) com a galeria/descrição da PDP, na cor que está no card. */
    /* Selos de benefício do produto (metafield custom.selos_atributos), abaixo da foto. */
    function selosDe(p) {
      if (!p.selos || !p.selos.length) return null;
      var ul = el('ul', 'conso-area-brinde__selos');
      p.selos.forEach(function (x) {
        var li = el('li', 'conso-area-brinde__selo');
        if (x.i) li.insertAdjacentHTML('beforeend', x.i);
        li.appendChild(el('span', '', x.t));
        ul.appendChild(li);
      });
      return ul;
    }

    /* Foto com o "Detalhes da peça" por cima (base da foto) e os selos embaixo.
       Produto com a tag `lancamento` ganha o selo "Lançamento" no canto (mesmo visual
       do conso-launch-badge da PDP). Só na foto grande: a miniatura da seleção de
       modelo e a do select de cada peça ficam sem. */
    function mediaDe(p, cor, src) {
      var media = el('div', 'conso-area-brinde__media');
      var foto = el('div', 'conso-area-brinde__foto');
      foto.appendChild(img(src, p.titulo, ''));
      if (p.lancamento) foto.appendChild(el('span', 'conso-area-brinde__lancamento', 'Lançamento'));
      if (p.handle) foto.appendChild(botaoDetalhes(p, cor));
      media.appendChild(foto);
      var selos = selosDe(p);
      if (selos) media.appendChild(selos);
      return media;
    }

    function botaoDetalhes(p, cor) {
      var v = p.variantes.find(function (x) { return x[1] === cor && x[3]; }) ||
        p.variantes.find(function (x) { return x[1] === cor; }) || p.variantes[0];
      var b = el('button', 'conso-area-brinde__detalhes');
      b.type = 'button';
      b.setAttribute('data-conso-detalhes', p.handle);
      if (v) b.setAttribute('data-conso-detalhes-variante', String(v[0]));
      b.setAttribute('data-conso-detalhes-titulo', p.titulo);
      b.setAttribute('data-conso-detalhes-sessao', oferta);
      /* cores com estoque, pra popup trocar de cor sem fechar */
      b.setAttribute('data-conso-detalhes-cores', JSON.stringify(coresComEstoque(p).map(function (c) {
        var vc = p.variantes.find(function (x) { return x[1] === c.nome && x[3]; });
        return { n: c.nome, v: vc ? String(vc[0]) : '', s: c.swatch || '' };
      })));
      if (v) b.setAttribute('data-conso-detalhes-cor', v[1] || '');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><path d="M12 7.5v.5"/></svg>';
      /* "Detalhes da peça"; na foto estreita do mobile, só "Detalhes" (CSS) */
      var rot = el('span', '', 'Detalhes');
      rot.appendChild(el('span', 'conso-area-brinde__detalhes-extra', ' da peça'));
      b.appendChild(rot);
      return b;
    }

    function totalKit() {
      var p = sel.principal.p;
      /* kitPrecoCheio: o kit é vendido pelo preço de N unidades avulsas, sem a escada */
      if (dados.kitPrecoCheio) {
        var u = precoRef(p).preco;
        return { unit: u, total: u * unidades, cheio: u * unidades, pct: 0 };
      }
      var base = precoRef(p).preco;
      if (precoModo === 'pague') {
        var total = base * Math.min(unidades, Number(dados.kitPague) || unidades);
        return { unit: Math.floor(total / unidades), total: total, cheio: base * unidades, pct: 0 };
      }
      if (precoModo === 'percentual') {
        var un = precoUnidade(base, p);
        return { unit: un, total: un * unidades, cheio: base * unidades, pct: descontoPct };
      }
      return precoKit(p, base, unidades);
    }

    /* Card do kit: foto (cor da unidade que o cliente mexeu por último), nome,
       preço do kit e, abaixo, cor e tamanho de cada unidade. */
    /* Um select por unidade: "Cor / Tamanho" das variantes com estoque. */
    function selectUnidade(s, idx) {
      var p = s.p;
      var campo = el('select', 'conso-area-brinde__select');
      campo.setAttribute('aria-label', String(dados.rotuloUnidade || 'Peça {n}').replace('{n}', idx + 1));
      var vazio = el('option', '', 'Escolha cor e tamanho');
      vazio.value = '';
      campo.appendChild(vazio);
      var atual = varianteDe(p, s.cor, s.tam);
      p.variantes.forEach(function (v) {
        if (!v[3]) return;
        var o = el('option', '', [v[1], v[2]].filter(Boolean).join(' / '));
        o.value = String(v[0]);
        if (atual && atual[0] === v[0]) o.selected = true;
        campo.appendChild(o);
      });
      campo.addEventListener('change', function () {
        var v = p.variantes.find(function (x) { return String(x[0]) === campo.value; });
        s.cor = v ? v[1] : '';
        s.tam = v ? v[2] : '';
        sel.slotAtivo = idx;
        render();
      });
      return campo;
    }

    /* "Camisa Social Anti-Amassado Flex Office" → "Kit 3 Camisas Social Anti-Amassado
       Flex Office": pluraliza SÓ a 1ª palavra, mesma regra dos produtos-kit da loja
       (ver kits-virada.py). */
    function nomeKit(titulo) {
      var partes = titulo.split(' ');
      var w = partes[0] || '';
      if (/ão$/i.test(w)) w = w.replace(/ão$/i, 'ões');
      else if (/[aeiou]$/i.test(w)) w = w + 's';
      else if (/[rz]$/i.test(w)) w = w + 'es';
      else if (/l$/i.test(w)) w = w.replace(/l$/i, 'is');
      partes[0] = w;
      return 'Kit ' + unidades + ' ' + partes.join(' ');
    }

    function kitCard() {
      var p = sel.principal.p;
      var wrap = el('div', 'conso-area-brinde__kit');
      var box = el('div', 'conso-area-brinde__produto');
      var corKit = sel.slots[sel.slotAtivo].cor || (coresComEstoque(p)[0] || {}).nome;
      box.appendChild(mediaDe(p, corKit, fotoDe(p, corKit)));

      var info = el('div', 'conso-area-brinde__info');
      info.appendChild(el('p', 'conso-area-brinde__nome', nomeKit(p.titulo)));
      var k = totalKit();
      info.appendChild(precoBaixou(k.total, k.cheio));
      if (dados.cashbackPct > 0) {
        var cbKit = el('div', 'conso-cashback-linha conso-area-brinde__cashback-card');
        preencherCashback(cbKit, k.total, dados);
        info.appendChild(cbKit);
      }
      info.appendChild(el('p', 'conso-area-brinde__unit', unidades + ' un. · ' + dinheiro(k.unit) + '/un'));
      info.appendChild(chipsCupom(k.total));
      if (p.sizing) info.appendChild(botaoMedidas(p));
      box.appendChild(info);
      wrap.appendChild(box);

      sel.slots.forEach(function (s, idx) {
        var slot = el('div', 'conso-area-brinde__slot');
        slot.appendChild(el('p', 'conso-area-brinde__slot-rotulo', String(dados.rotuloUnidade || 'Peça {n}').replace('{n}', idx + 1)));
        /* miniatura da cor escolhida ao lado do select (foto do modelo até escolher) */
        var linha = el('div', 'conso-area-brinde__slot-linha');
        linha.appendChild(img(s.cor ? fotoDe(p, s.cor) : p.imagem, '', 'conso-area-brinde__slot-thumb'));
        linha.appendChild(selectUnidade(s, idx));
        slot.appendChild(linha);
        wrap.appendChild(slot);
      });
      return wrap;
    }

    function renderPrincipal() {
      /* O card é redesenhado a cada escolha: guarda a rolagem do carrossel. */
      var antigo = ui.principal.querySelector('.conso-area-brinde__modelos');
      var rolagem = antigo ? antigo.scrollLeft : 0;
      ui.principal.textContent = '';
      if (principais.length > 1) {
        var lista = modelos(principais, sel.principal.p, function (p) {
          if (sel.principal.p === p) return;
          sel.principal = selecaoInicial(p);
          sel.slots = montarSlots();
          sel.slotAtivo = 0;
          if (brindeTodos) sel.brindesTodos = montarBrindesTodos(sel.brindesTodos);
          render();
        }, false, { carrossel: !!dados.modelosCarrossel });
        ui.principal.appendChild(lista);
        lista.scrollLeft = rolagem;
      }
      ui.principal.appendChild(ehKit ? kitCard() : produtoCard(sel.principal, false, render, null));
    }

    /* Mesma UI do passo 1: seletor de modelo em cima, cor e tamanho logo abaixo. */
    function renderBrinde() {
      if (semBrinde || !ui.brinde) return;
      ui.brinde.textContent = '';
      if (brindeTodos) {
        /* Uma de cada, todas obrigatórias: um card por camiseta. */
        sel.brindesTodos.forEach(function (s, idx) {
          var c = produtoCard(s, true, render, null);
          if (idx > 0) c.classList.add('conso-area-brinde__produto--seguinte');
          ui.brinde.appendChild(c);
        });
        return;
      }
      if (brindes.length > 1) {
        ui.brinde.appendChild(modelos(brindes, sel.brinde.p, function (p) {
          if (sel.brinde.p === p) return;
          sel.brinde = selecaoInicial(p);
          render();
        }, false));
      }
      ui.brinde.appendChild(produtoCard(sel.brinde, true, render, null));
    }

    function faltando() {
      var f = [];
      if (ehKit) {
        var faltam = sel.slots.filter(function (s) { return !varianteDe(s.p, s.cor, s.tam); }).length;
        if (faltam) f.push(faltam === 1 ? 'cor e tamanho de 1 peça' : 'cor e tamanho de ' + faltam + ' peças');
      } else if (!varianteDe(sel.principal.p, sel.principal.cor, sel.principal.tam)) f.push('o tamanho da peça');
      if (semBrinde) {
        /* sem passo 2 */
      } else if (brindeTodos) {
        var faltamB = sel.brindesTodos.filter(function (s) { return !varianteDe(s.p, s.cor, s.tam); }).length;
        if (faltamB) f.push(faltamB === 1 ? 'o tamanho de 1 camiseta' : 'o tamanho de ' + faltamB + ' camisetas');
      } else if (!varianteDe(sel.brinde.p, sel.brinde.cor, sel.brinde.tam)) f.push('o tamanho da camiseta');
      return f;
    }

    function renderRodape() {
      var s = sel.principal;
      var v = varianteDe(s.p, s.cor, s.tam);
      var ref = v ? { preco: v[4], compare: v[5] } : precoRef(s.p, s.cor);
      if (!ehKit && precoUnidade(ref.preco, s.p) < ref.preco) {
        ref = { preco: precoUnidade(ref.preco, s.p), compare: ref.preco };
      }
      if (ehKit) {
        var k = totalKit();
        ref = { preco: k.total, compare: k.cheio > k.total ? k.cheio : 0 };
      }
      ui.total.textContent = '';
      ui.total.appendChild(el('span', '', 'Total'));
      var val = el('span', 'conso-area-brinde__total-valor');
      if (ref.compare) val.appendChild(el('s', '', dinheiro(ref.compare)));
      val.appendChild(el('strong', '', dinheiro(ref.preco)));
      ui.total.appendChild(val);

      /* Linha de cashback (mesmo texto do snippet conso-cashback-linha da sessão 1):
         % da loja, em dobro na Área de membros, sobre o total que o cliente paga. */
      if (ui.cashback && dados.cashbackPct > 0) {
        preencherCashback(ui.cashback, ref.preco, dados);
        ui.cashback.hidden = false;
      }

      var f = faltando();
      ui.dica.textContent = f.length ? 'Falta escolher ' + f.join(' e ') + '.' : '';
      ui.dica.hidden = !f.length;
      ui.cta.disabled = f.length > 0 || enviando;
    }

    function render() {
      renderPrincipal();
      renderBrinde();
      renderRodape();
    }

    ui.cta.addEventListener('click', function () {
      if (enviando || faltando().length) return;
      /* Linhas do produto comprado: 1 variante, ou as N do kit somadas por variante
         (duas unidades iguais viram quantity 2 na mesma linha). */
      var linhas = [];
      var valor = 0;
      (ehKit ? sel.slots : [sel.principal]).forEach(function (s) {
        var v = varianteDe(s.p, s.cor, s.tam);
        var existente = linhas.find(function (l) { return l.id === Number(v[0]); });
        if (existente) existente.quantity += 1;
        else {
          var linha = { id: Number(v[0]), quantity: 1 };
          /* Peça do kit: a desconto-progressivo tira da escada (o kit daqui é pelo
             preço cheio) e a compre-ganhe conta só estas pro brinde do kit.
             marcarKit false (kits da Área com a escada pública): sem a marca. */
          if (ehKit && dados.marcarKit !== false) linha.properties = { _conso_area_kit: '1' };
          /* propsExtra: marcador da promo que cobra o preço (ex.: _conso_promo_camisetas_membros). */
          if (propsExtra) linha.properties = Object.assign({}, linha.properties || {}, propsExtra);
          linhas.push(linha);
        }
        valor += precoUnidade(v[4], s.p);
      });
      if (ehKit) valor = totalKit().total;
      var brindesSel = semBrinde ? [] : brindeTodos ? sel.brindesTodos : [sel.brinde];
      var linhasBrinde = brindesSel.map(function (s) {
        var props = {};
        props[dados.propBrinde] = s.p.titulo;
        return { id: Number(varianteDe(s.p, s.cor, s.tam)[0]), quantity: 1, properties: props };
      });

      enviando = true;
      ui.erro.hidden = true;
      ui.cta.disabled = true;
      ui.cta.classList.add('atc-loading');

      postCarrinho(linhas.concat(linhasBrinde))
        .then(function (resposta) {
          return carrinhoAtual()
            .catch(function () { return null; })
            .then(function (carrinho) {
              avisarTema(carrinho, resposta.sections);
              push({
                event: 'conso_area_brinde_add',
                area_oferta: oferta,
                area_produto: sel.principal.p.handle,
                area_brinde: brindesSel.map(function (s) { return s.p.handle; }).join(','),
                area_unidades: unidades,
                area_valor: valor / 100
              });
              abrirSacola();
            });
        })
        .catch(function (e) {
          ui.erro.textContent = (e && e.message) || 'Não foi possível adicionar ao carrinho.';
          ui.erro.hidden = false;
        })
        .then(function () {
          enviando = false;
          ui.cta.classList.remove('atc-loading');
          ui.cta.textContent = rotuloCta;
          renderRodape();
        });
    });

    render();
  }

  function arrancar() {
    document.querySelectorAll(SEL_ROOT).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
